// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSolanadevnet } from "../../../icons/mono/build/icon-solanadevnet.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SolanadevnetIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSolanadevnet.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SolanadevnetIcon.displayName = 'SolanadevnetIcon';
}

export default SolanadevnetIcon;